import React, { useState, useEffect, createRef } from "react";
import { Button, Col, Input, Label, Row, Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileUpload,
  faHourglassHalf,
  faSave,
} from "@fortawesome/free-solid-svg-icons";

//Components
import TextField from "../../../../components/TextField";
import ModalCustomized from "../../../../components/Modal/Modal";
import VotacaoColegiado from "./VotacaoColegiado";

//Helpers
import mascaras from "../../../../helpers/mascaras";
import { showMessage, showQuestion } from "../../../../helpers/message";

//API
import analiseInfracao_api from "../../../../api/analiseInfracao_api";
import colegiadoVotacao_api from "../../../../api/colegiadoVotacao_api";

//imagem
import { downloadBase64File } from "../../../../helpers/downloadFile";
import { objCampo, validarCampos } from "../../../../helpers/ValidadorDeCampos";
import infracoes_api from "../../../../api/infracoes_api";
import { useAuth } from "../../../../context/auth";

function initialStateFiscalizacaoInfracaoAcao(usuario_Id) {
  return {
    fiscalizacaoInfracao_Id: null,
    roteiroFiscalizacaoAcao_Id: null,
    observacoes: "",
    numeroProcessoInterno: "",
    formulario_Id: "",
    usuario_Id: usuario_Id,
    valorReincidencia: null,
  };
}

function AcoesPendentes({
  acoesPendentes,
  infracao,
  loadInfracaoItem,
  loadAcoesPendentes,
  setDocumento
}) {
  const { session, setLoading } = useAuth();

  //State para criar fiscalizacao ação
  const [acaoPendenteInfracao, setAcaoPendenteInfracao] = useState(
    initialStateFiscalizacaoInfracaoAcao(session?.id ?? null)
  );

  //State para pegar a ação selecionada
  const [acaoBotaoSelecionada, setAcaoBotaoSelecionada] = useState(null);

  //State para criar a ação votações
  const [acaoVotacao, setAcaoVotacao] = useState(null);

  //State para para Formulario Questão
  const [formularioPendente, setFormularioPendente] = useState([]);

  //State para pegar lista de colegiados Ativos
  const [listColegiadoAtivos, setListColegiadoAtivos] = useState([]);

  //State para pegar os documentos da ação
  const [documentosPendente, setDocumentosPendente] = useState([]);

  //State para observações de integraçoes
  const [observacoesIntegracoes, setObservacoesIntegracoes] = useState([]);

  //State para pegar os usuarios colegiados
  const [usuariosColegiados, setUsuariosColegiados] = useState([]);

  //State para pegar os valores referente a infração
  const [optionsValoresInfracao, setOptionsValoresInfracao] = useState([]);

  const [roteiroFiscalizacaoAcao, setRoteiroFiscalizacaoAcao] = useState(null);

  //State para pegar erros
  const [errorsAcaoVotacao, setErrorsAcaoVotacao] = useState({});

  const [permitirAcaoExterna, setPermitirAcaoExterna] = useState(
    session != null ? true : false
  );

  const loadFormulario = () => {
    if (
      acoesPendentes &&
      acoesPendentes.formulario &&
      acoesPendentes.formulario.formularioQuestoes.length > 0
    ) {
      setFormularioPendente([
        ...acoesPendentes.formulario.formularioQuestoes.map((value) => {
          value.valor = "";
          return value;
        }),
      ]);
    }
  };

  const loadDocumentos = () => {
    if (acoesPendentes && acoesPendentes?.documentos?.length > 0) {
      setDocumentosPendente([
        ...acoesPendentes.documentos.map((value) => {
          value.valorbase64 = "";
          value.ref = createRef(null);
          value.toolTip = false;
          return value;
        }),
      ]);
    }
  };

  const loadColegiados = async () => {
    setLoading(true);
    try {
      const response = await colegiadoVotacao_api.getListAtivos();
      setListColegiadoAtivos(response.data);
    } catch (err) {
      showMessage("Error", err?.message ?? "Erro na operação", "error", null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFormulario();
    loadDocumentos();
  }, [acoesPendentes]);

  //Estado de controle dos campos obrigatorios
  const [campoAcaoVotacao, setCampoAcaoVotacao] = useState([]);

  useEffect(() => {

    if (acaoBotaoSelecionada?.exigeVotacaoColegiado && session != null) {
      loadColegiados();
      setAcaoVotacao({
        ...acaoVotacao,
        observacoes: "",
        colegiado_Id: "",
        voto: "Pendente",
        usuario_Id: "",
        fiscalizacaoInfracao_Id: infracao.id,
        roteiroFiscalizacaoEtapa_Id:
          acaoBotaoSelecionada.roteiroFiscalizacaoEtapa_Id,
      });
      setCampoAcaoVotacao([
        objCampo({ name: "colegiado_Id", required: true }),
        objCampo({ name: "usuario_Id", required: true }),
      ]);
    }
  }, [acaoBotaoSelecionada]);

  //State para visibilidade do modal
  const [modalVisible, setModalVisible] = useState(false);

  const toggleModal = () => {
    setObservacoesIntegracoes([]);
    setModalVisible(!modalVisible);
  };

  //State para visibilidade do modal
  const [
    modalSelecionarValorInfracaoVisible,
    setModalSelecionarValorInfracaoVisible,
  ] = useState(false);

  const toggleSelecionarValorInfracaoModal = () => {
    setModalSelecionarValorInfracaoVisible(
      !modalSelecionarValorInfracaoVisible
    );
  };

  // Aviso de e-mail atualizado no cadastro, mostrado antes do POST quando
  // acoesPendentes.emailDivergente é true (só ocorre na análise interna).
  const [modalEmailVisible, setModalEmailVisible] = useState(false);
  const [roteiroFiscalizacaoAcaoEmailPendente, setRoteiroFiscalizacaoAcaoEmailPendente] = useState(null);

  const handleCancelarEscolhaEmail = () => {
    setModalEmailVisible(false);
    setRoteiroFiscalizacaoAcaoEmailPendente(null);
  };

  // Só fecha o modal e limpa a escolha depois que handleSubmitAcao confirma que
  // passou nas validações — evita perder a escolha do gestor se algo falhar.
  const handleEscolhaEmail = (atualizarEmailInfrator) => {
    const falhouValidacao = handleSubmitAcao(roteiroFiscalizacaoAcaoEmailPendente, atualizarEmailInfrator);
    if (falhouValidacao) return;

    setModalEmailVisible(false);
    setRoteiroFiscalizacaoAcaoEmailPendente(null);
  };

  //Tipos dos campos para as questões
  const typeOfFields = {
    Lista: "select",
    Texto: "text",
    Data: "date",
    Número: "text",
  };

  //Função para campos sem ser select
  const onChangeFormulario = (e, questao) => {
    const { value } = e.target;
    questao.valor = value;
    setFormularioPendente([
      ...formularioPendente.map((v) => {
        if (questao.id == v.id) return questao;
        return v;
      }),
    ]);
  };

  const onChangeObservacoesIntegracoes = (e, observacao) => {
    const { value } = e.target;
    const observacaoSalva = observacoesIntegracoes.filter(
      (v) => v.integracao_Id == observacao.integracao_Id
    );

    setObservacoesIntegracoes([
      ...observacoesIntegracoes.filter(
        (v) => v.integracao_Id != observacao.integracao_Id
      ),
      {
        ...(observacaoSalva && observacaoSalva.length > 0
          ? observacaoSalva[0]
          : {}),
        valor: value,
        integracao_Id: observacao.integracao_Id,
      },
    ]);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setAcaoPendenteInfracao({
      ...acaoPendenteInfracao,
      [name]: value,
    });
  };

  const onChangeAcaoVotacao = (value, e) => {
    const _acaoVotacao = {
      ...acaoVotacao,
      [e.name]: value ? value.value.toString() : null,
    };

    if (e.name == "colegiado_Id" && !!value?.value) {
      setUsuariosColegiados(
        ...listColegiadoAtivos
          .filter((x) => x.id == value.value)
          ?.map((u) =>
            u.usuarios?.map((v) => {
              return { value: v.id.toString(), label: v.nome };
            })
          )
      );
    }

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campoAcaoVotacao.filter((campo) => campo.name === e.name);
    const fieldError = validarCampos(_acaoVotacao, _campos);

    const _errors = { ...errorsAcaoVotacao };
    delete _errors[e.name];
    if (fieldError[1].length === 0) setErrorsAcaoVotacao({ ..._errors });
    else setErrorsAcaoVotacao({ ..._errors, ...fieldError[0] });

    setAcaoVotacao(_acaoVotacao);
  };

  //Função responsavel por exibir as orientações dos documentos
  const toggleTooltip = (documento) => {
    setDocumentosPendente(
      documentosPendente.map((value) => {
        if (value.documento_Id == documento.documento_Id)
          value.toolTip = !value.toolTip;
        else value.toolTip = false;
        return value;
      })
    );
  };

  //Ação realizada ao clicar no documento do card
  const handleClickCard = (ref) => {
    ref.current.click();
  };

  //Função de onChange do arquivo
  const handleFileChange = (documento, e, value) => {
    const FR = new FileReader();
    FR.addEventListener("load", function (evt) {
      setDocumentosPendente([
        ...documentosPendente.map((d) => {
          if (d.documento_Id == documento.documento_Id) {
            d.valorbase64 = evt.target.result;
            return d;
          }
          return d;
        }),
      ]);
    });
    if (e.target.files) FR.readAsDataURL(e.target.files[0]);
  };

  const handleSubmitAcao = (roteiroFiscalizacaoAcao_Id = null, atualizarEmailInfrator = false) => {
    if (acaoVotacao != null) {
      const _errors = validarCampos(acaoVotacao, campoAcaoVotacao);
      setErrorsAcaoVotacao(_errors[0]);

      if (_errors[1].length > 0) return true;
    }

    // Validação para número do processo interno obrigatório
    if (
      acaoBotaoSelecionada?.informarNumeroProcesso &&
      (!acaoPendenteInfracao.numeroProcessoInterno ||
        acaoPendenteInfracao.numeroProcessoInterno.trim() === "")
    ) {
      showMessage("Aviso", "Número do processo interno é obrigatório", "warning", null );
      return true;
    }

    if (
      documentosPendente.length > 0 &&
      documentosPendente.filter((d) => d.obrigatorio && d.valorbase64 == "")
        .length > 0
    ) {
      showMessage(
        "Aviso",
        "Todas os documentos obrigatórios precisam ser anexados",
        "warning",
        null
      );
      return true;
    }

    if (
      formularioPendente.length > 0 &&
      formularioPendente.some(
        (questao) => questao.obrigatorio && questao.valor == ""
      )
    ) {
      showMessage(
        "Aviso",
        "Todas as questões obrigatorias precisam ser respondidas!",
        "warning",
        null
      );
      return true;
    }

    let _acaoPendenteInfracao = {
      ...acaoPendenteInfracao,
      roteiroFiscalizacaoAcao_Id:
        roteiroFiscalizacaoAcao_Id ??
        acaoBotaoSelecionada?.roteiroFiscalizacaoAcao_Id,
      fiscalizacaoInfracao_Id: infracao.id,
      formulario_Id: acoesPendentes?.formulario?.id ?? null,
      respostas:
        formularioPendente.length > 0
          ? [
            ...formularioPendente.map((v) => {
              return {
                formularioQuestao_Id: v.id,
                questao: v.questao,
                valor: v.valor,
              };
            }),
          ]
          : null,
      documentos:
        documentosPendente.length > 0
          ? [
            ...documentosPendente.map((d) => {
              return { documento_Id: d.documento_Id, base64: d.valorbase64 };
            }),
          ]
          : null,
      observacoesIntegracoes: observacoesIntegracoes,
      acoesVotacao: acaoVotacao,
      atualizarEmailInfrator: atualizarEmailInfrator,
    };

    setLoading(true);
    analiseInfracao_api
      .PostFiscalizacaoInfracaoAcao(_acaoPendenteInfracao)
      .then((response) => {
        showMessage(
          "Sucesso",
          "Operação realizada com sucesso.",
          "success",
          () => {
            setModalVisible(false);
            setAcaoPendenteInfracao(
              initialStateFiscalizacaoInfracaoAcao(session?.id ?? null)
            );
            loadAcoesPendentes();
            loadInfracaoItem();
          }
        );
      })
      .catch((err) =>
        showMessage("Error", err.message ?? "Error na operação.", "error", null)
      )
      .finally(() => setLoading(false));
  };

  function confirmarAcao(roteiroFiscalizacaoAcao_Id, acao) {
    showQuestion(
      "Aviso",
      `Tem certeza de que deseja ${acao != null ? acao : "salvar"}?
                Não será possível retornar essa ação após a confirmação.`,
      "info",
      (confirmation) => {
        if (!confirmation) return;

        // E-mail do cadastro diverge do e-mail da infração — pergunta qual usar
        // antes de disparar o POST, em vez de seguir direto.
        if (acoesPendentes?.emailDivergente) {
          setRoteiroFiscalizacaoAcaoEmailPendente(roteiroFiscalizacaoAcao_Id);
          setModalEmailVisible(true);
          return;
        }

        handleSubmitAcao(roteiroFiscalizacaoAcao_Id);
      }
    );
  }

  async function handleConfirmarAcao(value) {
    if (value.gerarBoleto === true) {
      try {
        const { data } = await infracoes_api.getItem(infracao.infracao_Id);

        if (data && !!data.valorReincidencia && data.valorReincidencia > 0) {
          setAcaoPendenteInfracao({
            ...acaoPendenteInfracao,
            valorReincidencia: infracao.valor.toString(),
          });
          setRoteiroFiscalizacaoAcao({
            roteiroFiscalizacaoAcao_Id: value.roteiroFiscalizacaoAcao_Id,
            identificacao: value.identificacao,
          });
          setOptionsValoresInfracao([
            {
              label: `${infracao.valor.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}`,
              value: `${infracao.valor.toString()}`,
            },
            {
              label: `${data.valorReincidencia.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}`,
              value: `${data.valorReincidencia.toString()}`,
            },
          ]);
          setModalSelecionarValorInfracaoVisible(true);
        } else {
          return confirmarAcao(
            value.roteiroFiscalizacaoAcao_Id,
            value.identificacao
          );
        }
      } catch (ex) {
        showMessage("Error", ex?.message, "error", null);
      }
    } else {
      return confirmarAcao(
        value.roteiroFiscalizacaoAcao_Id,
        value.identificacao
      );
    }
  }

  return (
    <>

      {infracao != null &&
        infracao.analiseFinalizada != true &&
        acoesPendentes &&
        acoesPendentes.acoes?.length > 0 && (
          <>
            <ModalCustomized
              title={
                acoesPendentes?.formulario?.identificacao
                  ? "Formulário de " +
                  acoesPendentes?.formulario?.identificacao.toLowerCase()
                  : "Preencha os campos"
              }
              toggle={toggleModal}
              isOpen={modalVisible}
              btnClose={toggleModal}
            >

              {acaoBotaoSelecionada?.exigeVotacaoColegiado && (
                <>
                  <Row>
                    <Col md={12} lg={12}>
                      <TextField
                        name={"colegiado_Id"}
                        label={"* Colegiado"}
                        searchable
                        type={"select"}
                        options={listColegiadoAtivos.map((c) => {
                          return {
                            value: c.id.toString(),
                            label: c.identificacao,
                          };
                        })}
                        value={listColegiadoAtivos
                          .map((c) => {
                            return {
                              value: c.id.toString(),
                              label: c.identificacao,
                            };
                          })
                          .filter((v) => v.value == acaoVotacao.colegiado_Id)}
                        onChange={onChangeAcaoVotacao}
                        invalid={!!errorsAcaoVotacao.colegiado_Id}
                      />
                    </Col>
                  </Row>
                  {!!acaoVotacao?.colegiado_Id &&
                    usuariosColegiados.length > 0 && (
                      <Row>
                        <Col md={12} lg={12}>
                          <TextField
                            name={"usuario_Id"}
                            label={"* Relator"}
                            type={"select"}
                            searchable
                            options={usuariosColegiados}
                            value={usuariosColegiados?.filter(
                              (v) => v.value == acaoVotacao.usuario_Id
                            )}
                            onChange={onChangeAcaoVotacao}
                            invalid={!!errorsAcaoVotacao.usuario_Id}
                          />
                        </Col>
                      </Row>
                    )}
                </>
              )}

              {acaoBotaoSelecionada?.informarNumeroProcesso && (
                <Row className="px-2 mb-1">
                  <Col md={12} lg={12}>
                    <TextField
                      label={"Informar número do processo"}
                      type={"text"}
                      mask={mascaras.numeroMask}
                      name={"numeroProcessoInterno"}
                      onChange={onChange}
                      maxLength={30}
                      value={acaoPendenteInfracao.numeroProcessoInterno}
                      invalid={!!acaoPendenteInfracao.numeroProcessoInterno}
                    />
                  </Col>
                </Row>
              )}

              {acaoBotaoSelecionada?.acaoInfracaoIntegraca?.map(
                (value, index) => {
                  const observacao =
                    acaoBotaoSelecionada?.acaoInfracaoIntegraca.filter(
                      (v) => v.integracao_Id == value.integracao_Id
                    )[0];
                  const valorObservacao = observacoesIntegracoes.filter(
                    (o) => o.integracao_Id == observacao.integracao_Id
                  )[0];

                  return (
                    <Row className="px-1" key={index}>
                      <Col md={12} lg={12}>
                        <TextField
                          type={"textarea"}
                          label={observacao.descricaoNomeInputLabel}
                          onChange={(e) =>
                            onChangeObservacoesIntegracoes(e, observacao)
                          }
                          value={valorObservacao?.valor}
                        />
                      </Col>
                    </Row>
                  );
                }
              )}

              {acoesPendentes?.formulario?.formularioQuestoes?.map(
                (value, index) => {
                  const questao =
                    acoesPendentes?.formulario?.formularioQuestoes.filter(
                      (v) => value.id == v.id
                    )[0];
                  return (
                    <Row className="px-1" key={index}>
                      <Col md={12} lg={12}>
                        <TextField
                          label={`${questao.obrigatorio ? "*" : ""}${questao.questao
                            }`}
                          type={typeOfFields[questao.tipoValor]}
                          onChange={(e) => onChangeFormulario(e, questao)}
                          value={questao.valor}
                          invalid={questao.obrigatorio && questao.valor == ""}
                        />
                      </Col>
                    </Row>
                  );
                }
              )}
              <Row className="d-flex justify-content-center">
                <Col md={12} lg={3} className="text-center">
                  <Button
                    color="success"
                    onClick={() =>
                      confirmarAcao(null, acaoBotaoSelecionada?.identificacao)
                    }
                  >
                    <FontAwesomeIcon icon={faSave} /> Salvar
                  </Button>
                </Col>
              </Row>
            </ModalCustomized>

            <ModalCustomized
              title={"Confirme o valor da infração"}
              toggle={toggleSelecionarValorInfracaoModal}
              isOpen={modalSelecionarValorInfracaoVisible}
              btnClose={toggleSelecionarValorInfracaoModal}
              size={"md"}
              fullscreen={"lg"}
              widthPadrao={false}
            >
              <Row>
                <Col md="12" lg="12">
                  <TextField
                    type={"select"}
                    label="* Valor da infração"
                    name={"valorReincidencia"}
                    options={optionsValoresInfracao}
                    onChange={onChange}
                    value={acaoPendenteInfracao.valorReincidencia}
                  />
                </Col>
                <Col md="12" lg="12" className="mt-2">
                  <Button
                    color="success"
                    onClick={() => {
                      toggleSelecionarValorInfracaoModal();
                      confirmarAcao(
                        roteiroFiscalizacaoAcao.roteiroFiscalizacaoAcao_Id,
                        roteiroFiscalizacaoAcao.identificacao
                      );
                    }}
                    className="w-100"
                  >
                    Confirmar
                  </Button>
                </Col>
              </Row>
            </ModalCustomized>

            <ModalCustomized
              title={"Aviso de atualização de e-mail"}
              toggle={handleCancelarEscolhaEmail}
              isOpen={modalEmailVisible}
              btnClose={handleCancelarEscolhaEmail}
            >
              <Row className="px-1">
                <Col md={12} lg={12}>
                  <p>
                    O e-mail cadastrado deste infrator foi atualizado e é
                    diferente do e-mail registrado nesta infração. Escolha qual
                    e-mail deve ser usado a partir de agora:
                  </p>
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col md={12} lg={12}>
                  <strong>E-mail atual da infração:</strong>{" "}
                  {acoesPendentes?.emailInfracao}
                </Col>
              </Row>
              <Row className="px-1 mb-3">
                <Col md={12} lg={12}>
                  <strong>E-mail atualizado no cadastro:</strong>{" "}
                  {acoesPendentes?.emailCadastro}
                </Col>
              </Row>
              <Row className="d-flex justify-content-center">
                <Col md={12} lg={6} className="text-center mb-2">
                  <Button
                    color="secondary"
                    className="w-100"
                    onClick={() => handleEscolhaEmail(false)}
                  >
                    Continuar com o e-mail da infração
                  </Button>
                </Col>
                <Col md={12} lg={6} className="text-center mb-2">
                  <Button
                    color="success"
                    className="w-100"
                    onClick={() => handleEscolhaEmail(true)}
                  >
                    Continuar e atualizar o e-mail
                  </Button>
                </Col>
              </Row>
            </ModalCustomized>

            <div
              style={{ position: "relative" }}
              className="contentGroup mt-4 shadowFicha rounded-3 py-2"
            >
              <div className="text-white pointHistory pending d-lg-flex d-md-none noPrint">
                <FontAwesomeIcon size="xs" icon={faHourglassHalf} />
              </div>
              <h5 className="px-2 pb-2 d-flex justify-content-between align-items-center titleFicha">
                {acoesPendentes.descricao}
              </h5>

              <Row className="px-3 py-1 ">
                <div className="d-flex align-items-start justify-content-start gap-3">
                  {documentosPendente.length > 0 &&
                    documentosPendente.map((value, index) => (
                      <div key={index}>
                        <Button
                          key={index}
                          outline
                          color={
                            value.valorbase64 != "" ? "success" : "secondary"
                          }
                          onClick={() => handleClickCard(value.ref)}
                          style={{ position: "relative" }}
                          className="px-4"
                        >
                          <FontAwesomeIcon icon={faFileUpload} />
                          <span className="ms-2">
                            {(value.obrigatorio ? "*" : "") +
                              value.identificacao}
                          </span>
                          {value.orientacoes != "" && (
                            <>
                              <Tooltip
                                placement="top"
                                isOpen={value.toolTip}
                                target={`Tooltip${value.documento_Id}`}
                                toggle={() => toggleTooltip(value)}
                              >
                                {value.orientacoes}
                              </Tooltip>
                              <span
                                id={`Tooltip${value.documento_Id}`}
                                className="tooltipDocumento"
                              >
                                ?
                              </span>
                            </>
                          )}
                        </Button>
                        {value.base64 && value.tipo == "Arquivo" && (
                          <div className="mt-2">
                            <span
                              role="button"
                              className="text-primary"
                              style={{ fontSize: "9pt" }}
                              onClick={() =>
                                downloadBase64File(
                                  value.base64,
                                  "modelo_" + value.identificacao
                                )
                              }
                            >
                              Baixar Modelo
                            </span>
                          </div>
                        )}

                        {value.html && value.tipo == "Personalizado" && (
                          <div className="mt-2">
                            <span
                              role="button"
                              className="text-primary"
                              style={{ fontSize: "9pt" }}
                              onClick={() => setDocumento(value)}
                            >
                              Baixar Modelo
                            </span>
                          </div>
                        )}
                        <input
                          type="file"
                          ref={value.ref}
                          onChange={(e) => handleFileChange(value, e, value)}
                          style={{ display: "none" }}
                        />
                      </div>
                    ))}
                </div>
              </Row>

              <VotacaoColegiado
                acaoVotacao={acoesPendentes?.acaoVotacoes}
                loadAcoesPendentes={loadAcoesPendentes}
                loadInfracaoItem={loadInfracaoItem}
              />

              {session && !!acoesPendentes?.acaoVotacoes?.length == 0 && (
                <Row className="px-3 py-1">
                  <Col md={12} lg={12}>
                    <TextField
                      label={"Observação"}
                      type={"textarea"}
                      name={"observacoes"}
                      onChange={onChange}
                      value={acaoPendenteInfracao.observacoes}
                    />
                  </Col>
                </Row>
              )}

              {session == null && (
                <Row className="px-3 py-1 d-flex align-items-center">
                  <Col md={12} lg={12}>
                    <Input
                      type="checkbox"
                      onChange={(e) => setPermitirAcaoExterna(e.target.checked)}
                      value={permitirAcaoExterna}
                    />{" "}
                    <Label check>
                      Confirmo que as informações preenchidas e os documentos
                      anexados são verdadeiros
                    </Label>
                  </Col>
                </Row>
              )}

              {!!acoesPendentes?.acaoVotacoes?.length == 0 && (
                <div className="px-3 py-1 d-flex align-items-center justify-content-start">
                  {acoesPendentes.acoes?.map((value, key) => (
                    <div className="me-3" key={key}>
                      <Button
                        color={value.cor}
                        className="w-100"
                        onClick={() => {
                          if (
                            acoesPendentes.formulario ||
                            value.informarNumeroProcesso ||
                            value?.acaoInfracaoIntegraca?.length > 0 ||
                            value?.exigeVotacaoColegiado
                          ) {
                            setAcaoBotaoSelecionada(value);
                            toggleModal();
                          } else {
                            handleConfirmarAcao(value);
                          }
                        }}
                        disabled={!permitirAcaoExterna}
                      >
                        {value.identificacao}
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
    </>
  );
}

export default AcoesPendentes;
